import React from 'react'
import PropTypes from 'prop-types'
import { Container } from './stepbar-style'
import StepItem from './step-item'

const Stepbar = ({ currentStep }) => {
  return (
    <Container>
      <StepItem order={1} currentStep={currentStep} label={'Empresa'} />
      <StepItem order={2} currentStep={currentStep} label={'Responsável Legal'} />
      <StepItem order={3} currentStep={currentStep} label={'Endereço'} />
      <StepItem last order={4} currentStep={currentStep} label={'Segurança'} />
    </Container>
  )
}

Stepbar.propTypes = {
  currentStep: PropTypes.number.isRequired,
}
Stepbar.displayName = 'Stepbar'

export default Stepbar
